import React from 'react'
import { redirect, RouteObject } from 'react-router-dom'


import FeedPage from 'pages/FeedPage'
import ProjectsPage from 'pages/ProjectsPage'
import ProjectCreatePage from 'pages/ProjectCreatePage'
import ProjectDetailsPage from 'pages/ProjectDetailsPage'
import ProjectEditPage from 'pages/ProjectEditPage'
import ChartsPage from 'pages/ChartsPage'
import ProductsPage from 'pages/ProductsPage'
import { CanRoute } from 'shared/abilities'

import { ProjectDetailsHeader } from 'modules/Projects/components'
import { RedirectProjectToItsZone, RedirectWithZonePrefix, ZoneRouteValidator } from '../../redirects'
import { SBXLayout } from './Layout'

export const sbxRoutes: RouteObject[] = [
  // Routes for backwards compatibility
  // Section starts
  {
    path: '/feed',
    element: <RedirectWithZonePrefix />
  },
  {
    path: '/charts',
    element: <RedirectWithZonePrefix />
  },
  {
    path: '/products',
    element: <RedirectWithZonePrefix />
  },
  {
    path: '/projects',
    children: [
      {
        index: true,
        element: <RedirectWithZonePrefix />
      },
      {
        path: 'new',
        element: <RedirectWithZonePrefix />
      },
      {
        path: ':id',
        element: <RedirectProjectToItsZone />
      },
      {
        path: ':id/edit',
        element: <RedirectWithZonePrefix />
      }
    ]
  },
  // Section ends


  {
    path: '/:zoneAlias/:countryCode',
    element: <ZoneRouteValidator />,
    children: [
      {
        element: <SBXLayout />,
        children: [
          {
            // root path of the VALID zone-country pair
            index: true,
            loader: () => redirect('feed')
          },
          {
            path: 'feed',
            element: <FeedPage />
          },
          {
            path: 'charts',
            element: <ChartsPage />
          },
          {
            path: 'products',
            element: <ProductsPage />
          },
          {
            path: 'projects',
            element: <CanRoute I="read" a="Project" />,
            children: [
              {
                index: true,
                element: <ProjectsPage />
              },
              {
                path: ':id',
                element: <CanRoute I="read" a="Project" />,
                children: [
                  {
                    index: true,
                    element: (
                      <>
                        <ProjectDetailsHeader />
                        <ProjectDetailsPage />
                      </>
                    )
                  },
                  {
                    path: 'edit',
                    element: <CanRoute I="edit" a="Project" />,
                    children: [{
                      index: true,
                      element: <ProjectEditPage />
                    }]
                  }
                ]
              },
              {
                path: 'new',
                element: <CanRoute I="create" a="Project" />,
                children: [{
                  index: true,
                  element: <ProjectCreatePage />
                }]
              }
            ]
          }
        ]
      }
    ]
  }


]


